module.exports = __webpack_public_path__ + "static/media/acai-bowl-resize.e4e0add6.png";